export default __webpack_public_path__ + "static/media/OFFSITEPM.d3560eb0.svg";